import { Order } from 'storeTypes'
import { TransactionPayloadType } from './transactionsTypes'

export enum ClientSearchEnum {
    FETCH_CLIENT_SEARCH = 'fetch client search',
    SEARCH_CLIENT_BY_PHONE = 'SEARCH_CLIENT_BY_PHONE',
    FETCHING_CLIENT_SEARCH = 'fetching client search',
    CLEAR_CLIENT_SEARCH = 'clear client search'
}

export enum ClientSearchFilter {
    VILLAGE = 'village'
}

export type ClientSearchType = {
    clientId?: string
    firstName?: string
    lastName?: string
    fullName?: string
    primaryPhone?: string
}

export type ClientType = {
    age: null
    all_enrollment: number
    allEnrollment: number
    balance: number
    birth_year: null
    cash_account: string
    cash_balance: number
    certified_for_delivery: string
    client_code: string
    client_status: string
    country: string
    country_sharing_rule: string
    date: string
    date_created: string
    date_modified: number
    duplicate: boolean
    firstname: string
    fullname: string
    form_type: string
    goal_items?: Order[]
    group_leader: boolean
    group_role: string
    head_of_household: boolean
    last_season_goal_item: string
    last_voucher_date: string
    last_payment_date?: string
    lastname: string
    mobile_money_phone: string
    modification?: string
    payment_progress?: number
    phone: string
    phone_2: string
    phone_owner: string
    recent_year_delivered: string
    recent_year_enrolled: string
    reimbursement_choice: string
    savings_group_name: string
    sex: string
    sf_id: string
    smss?: TransactionPayloadType[]
    username: string
    uuid: string
    village: string
    village_id: string
    visit_requested: boolean
    zone: string
    _is_deleted?: boolean
    categories?: string[]
    /** Phone numbers for which this client is the default. Empty means not a default client. */
    default_client_contacts?: string[]
}

type ClientSearchPayloadType = {
    allClientList: ClientType[]
    searchParams: ClientSearchType
}

type ClientSearchByPhonePayloadType = {
    allClientList: ClientType[]
    searchParams: { primaryPhone: string }
}

export interface ClientSearchInterface {
    searchValue: ClientSearchType
    villageIds?: string[]
}

type FetchClientSearchType = {
    type: ClientSearchEnum.FETCH_CLIENT_SEARCH
    payload: ClientSearchPayloadType
}

type SearchClientByPhoneType = {
    type: ClientSearchEnum.SEARCH_CLIENT_BY_PHONE
    payload: ClientSearchByPhonePayloadType
}

type FetchingClientSearchType = {
    type: ClientSearchEnum.FETCHING_CLIENT_SEARCH
}

type ClearClientSearchType = {
    type: ClientSearchEnum.CLEAR_CLIENT_SEARCH
}

export type ClientSearchActionTypes =
    | FetchClientSearchType
    | SearchClientByPhoneType
    | FetchingClientSearchType
    | ClearClientSearchType
